<template>
    <div :key="$route.path"> 
    <div class="navDiv MobileHide" id="topheader">
            <nav class="navbar navbar-expand-sm navbar-light gamesNav">
              <div class="collapse navbar-collapse" id="navbarNav">
                <ul class="navbar-nav">
                  <li class="nav-item">
                    <router-link id="routerLink" class="leftEst" :to="{ name: 'LeaguePageGames', params: { id: id } }"> <img style="height: 22px; margin-right: 5px;" src="@/assets/results.png"> {{ $t('LanguageEn.txtResults') }}</router-link> 
                  </li>
                  <li class="nav-item">
                    <router-link id="routerLink" :to="{ name: 'LeaguePage', params: { id: id } }"> <img style="height: 22px; margin-right: 5px;" src="@/assets/leagueTable.png"> {{ $t('LanguageEn.txtTable') }} </router-link> 
                  </li>
                </ul>
              </div>
            </nav>
            <div style="color: black;">
                <router-view :key="$route.path"/>
            </div>
      </div>
      <nav class="nav navLinks MobileShow container-fluid" style="background: white; margin-bottom: 3px;">
       <div class="row" style="">
       <div class="col-5">
       <router-link id="routerLink" :to="{ name: 'LeaguePageGames', params: { id: id } }">{{ $t('LanguageEn.txtResults') }}</router-link>
       </div>
       <div class="col">
       <router-link id="routerLink" :to="{ name: 'LeaguePage', params: { id: id } }">{{ $t('LanguageEn.txtTable') }}</router-link>
       </div>
       </div>
    </nav>
      <router-view class="MobileShow"/>
    </div>
</template>

<script>


export default {
  name: 'LeaguePageNav',
  data(){
      return{
          id : '',
      }
  },
   async mounted(){
    this.id = this.$route.params.leagueId;

  },
  
}
</script>

<style scoped>
.navDiv{
    width: auto;
    height: auto;
    color: white;
    background: #f9f9f9;
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
}

.nav-item{
    font-size: small;
    
}
.nav-link{
    height: 40px;
    color: green !important;
    text-align: center;
}

.leftEst{
    border-top-left-radius: 5px;
}

#routerLink{
  padding-top: 10%;
    display: inline-block; 
    text-decoration: none;
    width: 111px !important;
    height: 40px !important;
    color: green;
    text-align: center !important;
}
#routerLink .navbar-nav li > a {
	text-transform: capitalize;
	transition: background-color 0.2s, color 0.2s;
}

    #routerLink .navbar-nav li > a:focus {
        background-image: linear-gradient(#39b44a , #1b5f20);
		color: #fff;
	}

.router-link-active{
    background-image: linear-gradient(#39b44a , #1b5f20);
    color: white !important;
}
/* Navbar link underline */

.gamesNav{
    background: white !important;
    border-bottom: 10px solid #1b5e20;
    padding: 0 !important;
    margin-left: 20px;
    padding-top: 10px !important;
    margin-right: 20px;
}

#topheader .navbar-nav li > a {
	text-transform: capitalize;
	transition: background-color 0.2s, color 0.2s;
}

    #topheader .navbar-nav li > a:focus {
        background-image: linear-gradient(#39b44a , #1b5f20);
		color: #fff !important;
	}

#topheader .navbar-nav li.active > a {
	background-color: #333;
	color: #fff;
}
@media only screen and (max-width: 770px) {
  body{
    background: #212529;
  }
  .navDiv2{
    width: 100%;
    height: 60px;
    color: white;
    background: #1b1d20;  
}
  .MobileHide {
    display: none;
  }
   #routerLink{
    padding-top: 8px;
    display: inline-block; 
    text-decoration: none;
    height: 40px;
    color: green;
    font-weight: 500;
    text-align: center;
}
}

@media only screen and (min-width: 770px) {
  .MobileShow {
    display: none;
  }
}
</style>
